import { useMutation } from '@tanstack/react-query';

import { type DSKPaymentProvider } from 'src/features/parkingManagement/api/paymentPaymentProviders/useGetDSKPaymentProvider';
import axios from 'src/lib/axios';
import { type MutationConfig } from 'src/lib/react-query';
import { type GeneralSmartParkError } from 'src/types';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = '/parkings/:parkingId/dsk-payment-provider/';

export type CreateDSKPaymentProviderFnType = typeof createDSKPaymentProvider;

export type DTO = {
    parkingId: string;
    username: string;
    password: string;
};

const createDSKPaymentProvider = ({ parkingId, ...data }: DTO): Promise<Omit<DSKPaymentProvider, 'id'>> => {
    return axios.post(formatResourcePath(RESOURCE, { parkingId }), data);
};

interface UseCreateDSKPaymentProvider extends MutationConfig<CreateDSKPaymentProviderFnType, GeneralSmartParkError> {}

export const useCreateDSKPaymentProvider = (options: UseCreateDSKPaymentProvider) =>
    useMutation({
        mutationFn: createDSKPaymentProvider,
        ...options,
    });
